// Auth Store
import { getField } from 'vuex-map-fields'

const state = {
  countries: [],
  countriesLoadedAt: 0,
}

const getters = {
  getField,
}

const COUNTRIES_CACHE_TTL = 24 * 60 * 60 * 1000

const actions = {
  getCountries({ commit, state }) {
    const isCacheValid =
      state.countries?.length &&
      Date.now() - state.countriesLoadedAt < COUNTRIES_CACHE_TTL

    if (isCacheValid) {
      return Promise.resolve(state.countries)
    }
    return new Promise(resolve => {
      this.api.items.getItem('countries').then(({ data }) => {
        commit('SET_COUNTRIES', data.results)
        resolve()
      })
    })
  },
}

const mutations = {
  SET_COUNTRIES: (state, payload) => {
    state.countries = payload
    state.countriesLoadedAt = Date.now()
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
